import { render, staticRenderFns } from "./purchaseConfirm.vue?vue&type=template&id=a61f66ce&scoped=true"
import script from "./purchaseConfirm.vue?vue&type=script&lang=js"
export * from "./purchaseConfirm.vue?vue&type=script&lang=js"
import style0 from "./purchaseConfirm.vue?vue&type=style&index=0&id=a61f66ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61f66ce",
  null
  
)

export default component.exports